import { v4 as uuidv4} from 'uuid';
export function getRandomUID(removeSeparators = false, addAlphaBeginning = false): string {
  let random =  uuidv4();
  if (addAlphaBeginning) {
    random = 'C' + random;
  }
  return removeSeparators ? random.split('-').join('') : random;
}
